var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{staticStyle:{"padding-top":"calc((100vh - 260px) / 2)"},attrs:{"image":"error","description":"授权失败， 请重新进入"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }